import { CRYPTO_TYPES } from '../../vsb/constants/partnering-networks';
import { ALL, FULL } from '../constants/common-enums';
import isEmptyObject from './is-empty-object';
import isEmptyString from './is-empty-string';

/** To support current BE enroll API convert dpaTransactionOptions->paymentOptions to List per API spec1.1
 * Consider dpaTransactionOptions->paymentOptions from init only
 * @param {object} dpaOptionsFromInit
 * @returns {object}
 */
const getDpaTransactionOptionsForEnroll = dpaOptionsFromInit => {
  if (!isEmptyObject(dpaOptionsFromInit)) {
    if (isEmptyString(dpaOptionsFromInit?.dpaBillingPreference)) {
      delete dpaOptionsFromInit.dpaBillingPreference;
    }

    if (isEmptyString(dpaOptionsFromInit?.dpaShippingPreference)) {
      delete dpaOptionsFromInit.dpaShippingPreference;
    }
    // To handle non-std Enum for billing and shipping preference before passing to /cards/ api
    if (dpaOptionsFromInit?.dpaBillingPreference === ALL) {
      dpaOptionsFromInit.dpaBillingPreference = FULL;
    }

    if (dpaOptionsFromInit?.dpaShippingPreference === ALL) {
      dpaOptionsFromInit.dpaShippingPreference = FULL;
    }
    if (dpaOptionsFromInit.hasOwnProperty('paymentOptions')) {
      const initPaymentOptions = dpaOptionsFromInit.paymentOptions;
      /*
       * VCO-14446 cards/ api is up to date with latest EMVCO spec that expects full format.
       * Visa SDK needs to support both short and full format since partners currently pass short (TAVV, DTVV).
       * So, if we get short format, map to full format before passing in cards/ request
       */
      const dynamicDataTypeFromInit = dpaOptionsFromInit?.paymentOptions?.dynamicDataType ?? '';
      if (!isEmptyString(dynamicDataTypeFromInit)) {
        initPaymentOptions.dynamicDataType =
          CRYPTO_TYPES.VISA?.[dynamicDataTypeFromInit.toUpperCase()] ?? dynamicDataTypeFromInit;
      }

      if (!Array.isArray(initPaymentOptions)) {
        delete dpaOptionsFromInit.paymentOptions;
        dpaOptionsFromInit.paymentOptions = [initPaymentOptions];
      }
      //the following changes applied to address VCO-14581 & VCO-14582
      if (isEmptyString(dpaOptionsFromInit.transactionType)) {
        delete dpaOptionsFromInit.transactionType;
      }
    }
  }
  return dpaOptionsFromInit;
};

export default getDpaTransactionOptionsForEnroll;
